/**
 * Desktop - Megadropdown molecule.
 */

// Imports
import {
  isEmpty,
} from '../../common/Utils';
import * as tablist from '../../common/widgets/Tablist';
import {
  headerId,
  navId,
} from '../organism/header';

// Constants
const dropdownId = 'mainNavDropDown';

const itemWithFocusClass = 'm-nav__item--has-focus';
const itemWithEntriesClass = 'm-nav__item--has-entries';
const headerWithDropdownOpenedClass = 'o-header--drop-down-opened';
const dropdownIsOpenedClass = 'm-nav--main-drop-down-opened';

const contentActive = 'active';

const showDelay = 500;
const hideDelay = 200;

/**
 * Reference to the header element.
 * @type {Object}
 */
let header = {};

/**
 * Reference to the drop down nav element.
 * @type {Object}
 */
let dropdown = {};

/**
 * Reference to the last active menu item.
 * @type {Object}
 */
let lastActiveMenuItem = null;

/**
 * Reference to the "show" timeout.
 * @type {Object}
 */
let showTimeout = null;

/**
 * Reference to the "hide" timeout.
 * @type {Object}
 */
let hideTimeout = null;

/**
 * Returns an indicator for whether or not the dropdown is opened.
 * @return {Boolean} Whether or not the dropdown is opened.
 */
function isOpened() {
  return dropdown.hasClass(dropdownIsOpenedClass);
}

/**
 * Hides content given a target element.
 * @param {Object} aoTarget - The target element.
 */
function hideContent(aoTarget, abIgnorePrevious) {
  if (abIgnorePrevious && (hideTimeout != null)) {
    clearTimeout(hideTimeout);
    hideTimeout = null;
  }

  hideTimeout = setTimeout(() => {
    if (!isEmpty(aoTarget) && $(aoTarget).length) {
      const $target = $(aoTarget);
      $target.removeClass(itemWithFocusClass);

      const $itemLink = $target.find('a');
      const sectionId = $itemLink.attr('data-sectionid');

      if (!isEmpty(sectionId)) {
        const $contentContainer = dropdown.children(`.m-nav__list[data-sectionid=${sectionId}]`);

        if ($contentContainer.length) {
          $contentContainer
            .removeClass(contentActive);
        }
      }
    }

    dropdown.css({
      height: 0,
    }).removeClass(dropdownIsOpenedClass);

    header.removeClass(headerWithDropdownOpenedClass);
  }, hideDelay);
}

/**
 * Shows content given a target element.
 * @param {Object} aoTarget - The target element.
 * @return {Boolean} Whether or not the content has been shown.
 */
function showContentContainer(aoTarget) {
  const $target = $(aoTarget);

  if (!$target.hasClass(itemWithEntriesClass)) {
    return false;
  }

  const itemLink = $target.find('a');
  if (!itemLink.length) {
    return false;
  }

  const sectionId = itemLink.attr('data-sectionid');
  if (isEmpty(sectionId)) {
    return false;
  }

  if (!dropdown.length) {
    return false;
  }

  // Save last active menu item
  lastActiveMenuItem = $target;

  const $contentContainer = dropdown.children(`.m-nav__list[data-sectionid=${sectionId}]`);
  if ($contentContainer.length) {
    dropdown.children('.m-nav__list:visible')
      .removeClass(contentActive)
      .hide();
    $contentContainer
      .addClass(contentActive)
      .show();

    $(`#${navId} > .m-nav__list > .m-nav__item`)
      .removeClass(itemWithFocusClass);
    $target
      .addClass(itemWithFocusClass);

    const height = $contentContainer.outerHeight();
    if (height > 0) {
      if (hideTimeout != null) {
        clearTimeout(hideTimeout);
        hideTimeout = null;
      }

      dropdown.css({
        height: `${height}px`,
      }).addClass(dropdownIsOpenedClass);

      header.addClass(headerWithDropdownOpenedClass);
    }

    return true;
  }

  return false;
}

/**
 * Shows content given a target element.
 * @param {Object} aoTarget - The target element.
 * @return {Boolean} Whether or not the content has been shown.
 */
function showContent(aoTarget) {
  let $target = null;

  if (!isEmpty(aoTarget) && $(aoTarget).length) {
    $target = $(aoTarget);
  } else if (!isEmpty(lastActiveMenuItem) && $(lastActiveMenuItem).length) {
    $target = $(lastActiveMenuItem);
  }

  if (showTimeout != null) {
    clearTimeout(showTimeout);
    showTimeout = null;
  }

  if ($target == null) {
    hideContent();

    return false;
  }

  if (isOpened() && ($target.get(0).offsetTop > lastActiveMenuItem.get(0).offsetTop)) {
    // Wait to see if the new target is really intended

    showTimeout = setTimeout(() => {
      showContentContainer($target);
    }, showDelay);

    return false;
  }

  const showSuccess = showContentContainer($target);
  if (!showSuccess) {
    hideContent();
  }

  return showSuccess;
}

/**
 * Sets event handlers.
 */
function setEventHandlers() {
  // Main navigation list
  $(`#${navId} > .m-nav__list > .m-nav__item`)
    .mouseenter(function onMouseenter() {
      showContent($(this));
    })
    .mouseleave(function onMouseleave() {
      hideContent($(this), true);
    });

  // Drop down related to the main navigation list
  dropdown
    .mouseenter(() => {
      // Clear timeouts

      if (hideTimeout != null) {
        clearTimeout(hideTimeout);
        hideTimeout = null;
      }

      if (showTimeout != null) {
        clearTimeout(showTimeout);
        showTimeout = null;
      }

      // Reset the last active menu item
      // as active if needed
      showContentContainer(lastActiveMenuItem);
    })
    .mouseleave(() => {
      // Hide content

      hideContent(lastActiveMenuItem);
    });
}

/**
 * Initialization of the megadropdown.
 */
function init() {
  $(() => {
    // Save reference to the header element
    header = $(`#${headerId}`);

    // Save reference to the drop down nav element
    dropdown = $(`#${dropdownId}`);

    // Set event handlers
    setEventHandlers();

    // Init tablist
    tablist.create(
      `#${navId}  > .m-nav__list[role="tablist"]`,
      {
        change: (aoEvent, aoUI) => {
          if (!isEmpty(aoUI) && aoUI) {
            if (aoUI.fromTab) {
              hideContent($(aoUI.fromTab).closest('.m-nav__item'));
            }

            if (aoUI.toTab) {
              showContent($(aoUI.toTab).closest('.m-nav__item'));
            }
          }
        },
        handleContentDisplay: false,
      }
    );
  });
}

// Named exports - Constants
export {
  dropdownId,
  itemWithFocusClass,
  itemWithEntriesClass,
  headerWithDropdownOpenedClass,
  dropdownIsOpenedClass,
};

// Named exports - Functions
export {
  init,
};



// WEBPACK FOOTER //
// ./js/desktop/molecule/nav--main-drop-down.js